import SeoHead from "@/components/SeoHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";
import LocalFaqSection from "./components/LocalFaqSection";

const localServices = [
  {
    icon: "ri-home-4-line",
    title: "Pose de carrelage à Crans-Montana",
    desc: "Pose de carrelage à Crans-Montana. Grands formats, marbre, pierre naturelle — on travaille avec des matériaux exigeants et on les pose avec la précision qu'ils demandent.",
  },
  {
    icon: "ri-drop-line",
    title: "Rénovation salle de bain à Crans-Montana",
    desc: "Rénovation de salle de bain à Crans-Montana. Hammam, baignoire îlot, douche XXL — on livre des prestations à la hauteur des attentes de cette station.",
  },
  {
    icon: "ri-water-flash-line",
    title: "Douche italienne à Crans-Montana",
    desc: "Douche italienne à Crans-Montana. Receveur invisible, paroi panoramique, grand format. Le luxe, c'est aussi un joint droit et une pente qui évacue parfaitement.",
  },
  {
    icon: "ri-layout-grid-line",
    title: "Faïence & mosaïque à Crans-Montana",
    desc: "Faïence et mosaïque à Crans-Montana. Des créations qui apportent du caractère aux espaces résidentiels. On travaille avec les matériaux de qualité et on les pose avec soin.",
  },
  {
    icon: "ri-sun-line",
    title: "Carrelage extérieur & piscine à Crans-Montana",
    desc: "Terrasses et contours de piscine à Crans-Montana. Carrelage technique antidérapant, résistant au gel et aux UV. En altitude, les matériaux doivent être à la hauteur.",
  },
];


const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Accueil",
      "item": "https://carreaux-bat.ch/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Crans-Montana",
      "item": "https://carreaux-bat.ch/crans-montana"
    }
  ]
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Carrelage et Rénovation à Crans-Montana, Valais",
  "description": "Pose de carrelage haut de gamme et rénovation de salle de bain à Crans-Montana. Marbre, pierre naturelle, douche italienne en station de prestige. Artisan carreleur.",
  "url": "https://carreaux-bat.ch/crans-montana",
  "mainEntity": {
    "@type": "LocalBusiness",
    "name": "Carreaux-Bat Valais",
    "telephone": "+41 77 511 75 52",
    "areaServed": {
      "@type": "City",
      "name": "Crans-Montana",
      "containedInPlace": {
        "@type": "AdministrativeArea",
        "name": "Valais"
      }
    }
  }
};

export default function CransMontanaPage() {
  return (
    <div className="min-h-screen">
      <SeoHead
        title="Entreprise de Carrelage & Carreleur à Crans-Montana à Proximité | Carreaux-Bat Valais"
        description="Vous cherchez un carreleur à proximité de Crans-Montana ? Entreprise de carrelage et société de carrelage à Crans-Montana, Valais. Service de carrelage haut de gamme par carreleur près de chez vous à Crans-Montana, Crans-sur-Sierre, Montana, Lens, Chermignon. Pose de carrelage, marbre, douche italienne, terrasse piscine."
        keywords="carreleur à proximité de Crans-Montana, entreprise de carrelage à proximité de Crans-Montana, société de carrelage à proximité de Crans-Montana, carreleur près de chez moi Crans-Montana, entreprise de carrelage près de chez vous Crans-Montana, service de carrelage à proximité Crans-Montana, entreprise de carrelage Crans-Montana, société de carrelage Crans-Montana, service de carrelage Crans-Montana, carreleur Crans-Montana, pose de carrelage Crans-Montana, rénovation salle de bain Crans-Montana, douche italienne Crans-Montana, carrelage haut de gamme Valais, marbre Crans-Montana, artisan carreleur station ski"
        canonical="https://carreaux-bat.ch/crans-montana"
        ogTitle="Carrelage & Rénovation à Crans-Montana à Proximité — Artisan Carreleur en Station"
        ogDescription="Vous cherchez un carreleur à proximité de Crans-Montana ? Pose de carrelage haut de gamme, rénovation salle de bain et douche italienne à Crans-Montana. Matériaux nobles et finitions de précision."
        ogImage="/images/crans-montana-hero.jpg"
        geoPosition="46.3098;7.4691"
        geoPlacename="Crans-Montana, Valais, Suisse"
        geoRegion="CH-VS"
      schema={{
        "@context": "https://schema.org",
        "@graph": [webPageSchema, breadcrumbSchema]
      }}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <img
          src="/images/crans-montana-hero.jpg"
          alt="Carrelage Crans-Montana Valais"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block mb-4 px-4 py-1.5 bg-amber-700/80 text-white text-xs font-medium tracking-widest uppercase rounded-full">
            Station de Prestige
          </span>
          <h1 className="text-5xl font-bold text-white mb-4">Entreprise de Carrelage & Carreleur à Crans-Montana</h1>
          <p className="text-white/70 max-w-xl mx-auto text-sm leading-relaxed">
            Crans-Montana, c'est un autre monde. On travaille ici avec du marbre, de la pierre naturelle, des grands formats exigeants. C'est du travail de précision, et on aime ça.
          </p>
          <div className="flex items-center justify-center gap-2 mt-6 text-sm text-white/50">
            <Link to="/" className="hover:text-amber-400 transition-colors">Accueil</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Crans-Montana</span>
          </div>
        </div>
      </section>

      {/* Description longue */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Crans-Montana, Valais</span>
              <h2 className="mt-2 text-3xl font-bold text-stone-900 mb-6">Crans-Montana, le luxe à 1500 mètres</h2>
              <div className="space-y-4 text-sm text-stone-500 leading-relaxed">
                <p>
                  Crans-Montana est l&apos;une des stations les plus prestigieuses de Suisse, située sur un plateau ensoleillé à 1 500 mètres d&apos;altitude, surplombant la vallée du Rhône avec une vue imprenable sur les Alpes valaisannes et le Mont-Blanc. La station, qui compte environ 10 000 habitants permanents, accueille chaque année des milliers de visiteurs attirés par son golf, ses pistes de ski et son atmosphère chic.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Carreleur à Crans-Montana — Pose de carrelage haut de gamme</h3>
                <p>
                  Le plateau de Crans-Montana offre un cadre de vie exceptionnel : un ensoleillement généreux, un air pur de montagne, et une infrastructure de premier ordre avec des boutiques de luxe, des restaurants gastronomiques, un casino et des hôtels cinq étoiles. Le site est également réputé pour ses centres de bien-être et ses spas haut de gamme, qui font de la station une destination privilégiée pour le tourisme de santé et de détente.
                </p>
                <p>
                  L&apos;immobilier à Crans-Montana se caractérise par un parc résidentiel varié : chalets traditionnels en bois et pierre, appartements dans des résidences modernes, et villas contemporaines avec vue panoramique. Les attentes en matière de finition sont élevées, et les propriétaires investissent dans des matériaux de qualité, des installations adaptées et un travail fait main.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Entreprise de carrelage à Crans-Montana — Douche italienne et rénovation salle de bain</h3>
                <p>
                  Notre équipe intervient régulièrement à Crans-Montana. On connaît les contraintes de l&apos;altitude : matériaux qui résistent aux variations de température, étanchéité bien faite, et des finitions qui tiennent face au climat de montagne. Que ce soit une salle de bain dans un chalet familial ou l&apos;aménagement d&apos;un spa dans une résidence, on pose du carrelage comme il faut.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Société de carrelage à Crans-sur-Sierre, Montana et Lens</h3>
                <p>
                  Nous desservons l&apos;ensemble du plateau : Crans-sur-Sierre, Montana, Lens, Chermignon d&apos;en-Bas et d&apos;en-Haut. Envoyez-nous un message, on vient vous voir sur le plateau pour discuter de votre projet.
                </p>
              </div>
            </div>
            <div>
              <div className="relative rounded-lg overflow-hidden h-96 mb-6">
                <img
                  src="/images/crans-montana-realisation.jpg"
                  alt="Réalisation carrelage Crans-Montana"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">10 000</p>
                  <p className="text-xs text-stone-500 mt-1">Habitants permanents</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">1500 m</p>
                  <p className="text-xs text-stone-500 mt-1">Altitude</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">48h</p>
                  <p className="text-xs text-stone-500 mt-1">Délai d&apos;intervention</p>
                </div>
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">Sur mesure</p>
                  <p className="text-xs text-stone-500 mt-1">On vient vous voir</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services locaux */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Prestations locales</span>
            <h2 className="mt-3 text-3xl font-bold text-stone-900">Nos services à Crans-Montana</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {localServices.map((service) => (
              <div key={service.title} className="bg-white rounded-lg p-6 border border-stone-100 hover:border-amber-200 transition-colors">
                <div className="w-11 h-11 flex items-center justify-center bg-amber-50 rounded-lg mb-4">
                  <i className={`${service.icon} text-amber-700 text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-stone-900 mb-2">{service.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed">{service.desc}</p>
              </div>
            ))}
            <div className="bg-amber-700 rounded-lg p-6 flex flex-col justify-between">
              <div>
                <h3 className="text-base font-semibold text-white mb-2">Devis sur mesure à Crans-Montana</h3>
                <p className="text-sm text-amber-100 leading-relaxed">Envoyez-nous un message, on vient vous voir sur le plateau. On regarde votre espace, on discute, et on vous dit franchement ce qu'on peut faire.</p>
              </div>
              <Link
                to="/contact"
                className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-white text-amber-700 text-sm font-medium rounded-full hover:bg-amber-50 transition-colors whitespace-nowrap"
              >
                Demander un devis
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-stone-900">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Votre projet à Crans-Montana</h2>
          <p className="text-stone-400 text-sm mb-8 max-w-xl mx-auto">
            Le plateau de Crans-Montana demande des matériaux qui résistent au gel et aux variations de température. On connaît les fournisseurs de la région et les techniques de pose adaptées à l'altitude. Discrétion et réactivité, c'est comme ça qu'on travaille ici.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-amber-700 text-white font-medium rounded-full hover:bg-amber-600 transition-colors whitespace-nowrap"
            >
              Devis à Crans-Montana
            </Link>
            <a
              href="tel:+41775117552"
              className="px-8 py-3.5 border border-stone-600 text-stone-300 font-medium rounded-full hover:border-amber-600 hover:text-amber-400 transition-colors whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line"></i>
              +41 77 511 75 52
            </a>
          </div>
        </div>
      </section>

      <LocalFaqSection
        city="Crans-Montana"
        faqs={[
          {
            question: "Travaillez-vous avec du marbre et de la pierre naturelle à Crans-Montana ?",
            answer: "Oui, c'est même une de nos spécialités. À Crans-Montana, les clients attendent des matériaux nobles : marbre de Carrare, pierre de Travertin, ardoise. On les pose avec la précision qu'ils méritent, en respectant les spécificités de l'altitude et du climat de montagne."
          },
          {
            question: "Quels matériaux recommandez-vous pour l'altitude de Crans-Montana ?",
            answer: "À 1 500 mètres d'altitude, les variations de température sont violentes. On recommande des grès cérame de qualité supérieure, résistants au gel et aux UV. Pour les terrasses et contours de piscine, on utilise des carrelages techniques antidérapants avec des joints spéciaux extérieur qui résistent au froid."
          },
          {
            question: "Faites-vous des terrasses de piscine à Crans-Montana ?",
            answer: "Oui, on réalise régulièrement des plages de piscine et des terrasses à Crans-Montana. On travaille avec des carrelages antidérapants certifiés R12, résistants au gel, au sel et aux produits de traitement de l'eau. L'étanchéité est primordiale, et on la fait avec le plus grand soin."
          },
          {
            question: "Intervenez-vous à Lens et Chermignon depuis Crans-Montana ?",
            answer: "Oui, on desservit l'ensemble du plateau : Crans-sur-Sierre, Montana, Lens, Chermignon d'en-Bas et d'en-Haut. Notre connaissance du terrain nous permet d'intervenir rapidement et de livrer les matériaux sans problème, même par les chemins de montagne."
          },
          {
            question: "Comment gérez-vous les livraisons de matériaux en altitude ?",
            answer: "On connaît les fournisseurs de la région et les accès au plateau. Pour les matériaux lourds ou les grands formats, on planifie la livraison en fonction des conditions météo et des accès. On a l'habitude de travailler en altitude, et on sait anticiper les contraintes logistiques."
          },
          {
            question: "Proposez-vous des finitions luxe pour les résidences de prestige ?",
            answer: "Absolument. À Crans-Montana, on travaille sur des chalets et des appartements de très haut standing. On propose des joints invisibles, des grands formats XXL, des mosaïques sur mesure, et des finitions qui correspondent aux attentes d'une clientèle exigeante. Discretion et professionnalisme garantis."
          }
        ]}
      />

      <Footer />
    </div>
  );
}
